export type PermissionFieldProfileId =
    | "gate.api_scope.page"
    | "gate.api_scope.widget"
    | "runtime.capabilities.business_rule"
    | "runtime.capabilities.dynamic_api_script"
    | "runtime.capabilities.platform_job"
    | "dynamic_api.endpoint_scope.freeform";

export type PermissionFieldKind = "gate_api_scope" | "runtime_capabilities" | "freeform_scope";

export const PERMISSION_ARRAY_FIELD_TYPE = "PERMISSION_ARRAY" as const;

export type PermissionArrayFieldType = typeof PERMISSION_ARRAY_FIELD_TYPE;

export interface PermissionOption {
    value: string;
    label: string;
    group: string;
}

export interface PermissionFieldProfile {
    id: PermissionFieldProfileId;
    kind: PermissionFieldKind;
    label: string;
    options: PermissionOption[];
    allowSelfCapabilities?: boolean;
    allowWildcard?: boolean;
    allowFlussDefinitions?: boolean;
}
